import React, {useEffect} from 'react';
import {createMuiTheme, makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeUp from '@material-ui/icons/VolumeUp';
import { ThemeProvider } from "@material-ui/styles";
import {VolumeMute, VolumeOff} from "@material-ui/icons";
import {IconButton} from "@material-ui/core";
const useStyles = makeStyles({
    root: {
        width: "auto",
    },
    slider: {
        height:100,
        flexDirection:"column",
        display:"flex",
        position:"absolute",
        bottom:50,
        left:18
    }
});
const muiTheme = createMuiTheme({
    overrides: {
        MuiSlider: {
            thumb: {
                color: "pink"
            },
            track: {
                background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)"
            },
            rail: {
                color: "black"
            }
        }
    }
});
export default function VolumnControl(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState<number>(props.value);
    const [previousValue, setPreviousValue] = React.useState<number>(props.value);
    const [seeking, setSeeking] = React.useState<boolean>(false);
    const [inProp, setInProp] = React.useState(false);
    const [mute, setMute] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {

            setValue(props.value);

    }, [props.value]);
    const handleChange = (event: any, newValue: number | number[]) => {
        setValue(newValue as number);
        props.onChange(newValue as number);
        setMute(newValue == 0)


    };
    const handleChangeCommitted = (event: any, newValue: number | number[]) => {
        setValue(newValue as number);
        props.onChange(newValue as number);
        setOpen(false)

    };

    const handleBlur = () => {
        console.log("BLUR");
        setOpen(false)
    }
    const toggleOpen = () => {
        if(mute) {
            console.log("set mute false")
            setMute(false);
            setValue(previousValue);
            props.onChange(previousValue as number);
            setOpen(false)
        } else {
            setOpen(!open);
        }
    }

    const toggleMute = () => {
        if(!mute) {
            console.log("set mute true")

            setMute(true)
            setPreviousValue(value);
            setValue(0);
            props.onChange(0 as number);
            setOpen(false)


        } else {

            console.log("set mute false")
            setMute(false);
            setValue(previousValue);
            props.onChange(previousValue as number);
            setOpen(false)

        }


    }

    const maxVolume = () => {
        setMute(false);
        setValue(100);
        props.onChange(100 as number);
    }
    let sliderRef = React.createRef();


    const volumeSlider =  open ?
                            <div className={classes.slider} >
                                    <IconButton size={'small'}  aria-label={mute ? 'Un-mute' : 'mute'} color="secondary" onClick={maxVolume}>
                                        <VolumeUp />
                                    </IconButton>
                                    <ThemeProvider theme={muiTheme}>
                                        <Slider
                                            orientation="vertical"
                                            value={value}
                                            onChangeCommitted={handleChangeCommitted}
                                            onChange={handleChange}
                                            valueLabelDisplay="auto"
                                        />
                                    </ThemeProvider>
                            </div>
                        : null;

    let volumeButton = <VolumeDown />;

    if(value > 0 ){
        volumeButton =  <VolumeUp />
    } else {
        volumeButton =  <VolumeOff />
    }

    return (
        <div className={classes.root} >
            {volumeSlider}

                <IconButton
                    size={'small'}
                    aria-label={mute ? 'Un-mute' : 'Mute'}
                    color="secondary"
                    onClick={toggleMute}
                    style={{display:open?"inherit":"none"}}
                    aria-expanded={open}

                >
                    {value > 0 ? <VolumeDown /> : <VolumeOff/>}
                </IconButton>

                <IconButton
                    size={'small'}
                    aria-label={mute ? 'Un-mute' : 'mute'}
                    color="secondary"
                    onClick={toggleOpen}
                    style={{display:open?"none":"inherit"}}

                >
                    {volumeButton}
                </IconButton>


        </div>
    );
}
